import { Postal_CodesClient as PostalCodeClient } from './fo.api.service';

const API_URL = window.config?.VITE_API_HOST;
class PostalCodeService {

  constructor(token) {
    this.client = new PostalCodeClient(API_URL);
    this.client.setAuthToken(token);
  }

  getPostalCodes() {
    return new Promise((resolve, reject) => {
      this.client.postalCodeList()
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getPostalCode(id) {
    return new Promise((resolve, reject) => {
      this.client.postalCodeGet(id)
        .then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
    })
  }
  getPostalCodePrefixes() {
    return new Promise((resolve, reject) => {
      this.client
        .postalCodePrefixList()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getPostalCodeLaneAvailablePrefixes() {
    return new Promise((resolve, reject) => {
      this.client
        .postalCodeLaneAvailablePrefixList()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default PostalCodeService;
